<template lang="pug">

.l-page.pt-4
  .lessons-container
    navigations(
      :start-date="startDate"
      :end-date="endDate"
    )

    t-loader(v-if="loading")

    template(v-else)
      .weekdays-empty.mt-8(v-if="!days.length") Нет занятий

      template(v-else)
        template(v-if="lessonsColumnDirection && $vuetify.breakpoint.name !== 'xs'")
          .mt-6
          template(v-for="day, i in days")
            .mt-6(v-if="i > 0")
            card-lessons-column(
              :weekday="day.weekday"
              :times="day.times"
              is-teachers
            )

        template(v-else)
          v-row.mt-8
            v-col(v-for="day in days" :key="day.weekday" :cols="countCols")
              card-lessons(
                :weekday="day.weekday"
                :times="day.times"
                is-teachers
              )

  .mt-10

</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { shortFio } from '@/common'
import navigations from './components/navigations'
import cardLessons from './components/card-lessons/cardLessons'
import cardLessonsColumn from './components/column-lessons/cardLessonsColumn'
import moment from 'moment'

export default {
  name: 'TeacherLessons',

  components: {
    navigations,
    cardLessons,
    cardLessonsColumn
  },

  computed: {
    ...mapState('lessons/teacher', [
      'teacher',
      'lessons',
      'startDate',
      'endDate',
      'loading'
    ]),
    ...mapGetters('lessons/teacher', ['days']),
    ...mapState('navigations', ['date']),
    ...mapGetters('bootstrap', ['isSchool', 'fullTeacherFio', 'lessonsColumnDirection']),

    isMobile() {
      return ['xs'].includes(this.$vuetify.breakpoint.name)
    },

    isTablet() {
      return ['xs', 'sm'].includes(this.$vuetify.breakpoint.name)
    },

    countCols() {
      if (this.isMobile) return 12
      if (this.isTablet) return 6

      return 4
    },
  },

  async created() {
    const date = moment(this.$route.query.date).isoWeekday(1).format('YYYY-MM-DD')
    const response = await this.$store.dispatch('lessons/teacher/fetch', {
      teacherId: this.$route.params.teacherId,
      date,
    })

    if (!response.teacher) {
      this.$router.push({
        name: 'main',
      })
      return
    }

    const fio = this.fullTeacherFio ? response.teacher.fio : shortFio(response.teacher.fio)
    const position = response.teacher.position

    this.$store.commit('navigations/updateDate', date)

    this.$store.commit('breadcrumbs/update', [
      { text: this.isSchool ? 'Учителя' : 'Преподаватели', exact: true, to: { name: 'teachers' } },
      { text: `${position || ''} ${fio}`.trim() },
    ])
  },

  watch: {
    date(date) {
      this.$store.dispatch('lessons/teacher/fetch', {
        teacherId: this.$route.params.teacherId,
        date,
      })
    },
  },
}
</script>

<style lang="sass" scoped>

.weekdays-empty
  text-align: center
  font-size: 18px
  font-weight: 700
  width: 100%
  color: #6c6c6c

.t-loader
  margin-top: 80px

.lessons-container
  max-width: 1200px
  margin: 0 auto
  padding: 0 24px

  @media (max-width: 768px)
    padding: 0 16px

  @media (max-width: 480px)
    padding: 0 20px

</style>
